// 接口域名管理
export default {
    // baseURL: "https://www.xsdjp.com/api/",
    baseURL: "https://www.xsdjp.com/api/",
    // baseURL: "/api/",
};



// WEBPACK FOOTER //
// ./src/request/base.js